/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useRef, useState } from "react";
import Modal from "../global/Modal";
import ic_chart_big_circle from "../../assets/images/pictures/icon/ic_charts_big_circle.svg";
import ic_devices from "../../assets/images/pictures/icon/ic_devices_circle.svg";
import ic_paper_circle from "../../assets/images/pictures/icon/ic_paper_circle.svg";
import ic_person_circle from "../../assets/images/pictures/icon/ic_person_circle.svg";
import ic_setting from "../../assets/images/pictures/icon/ic_settings_circle.svg";
import ic_globe_big_circle from "../../assets/images/pictures/icon/ic_globe_big_circle.svg";
import map_final from "../../assets/images/pictures/southeast_asia_map_4.png";
import ic_persons_big_circle from "../../assets/images/pictures/icon/ic_persons_big_circle.svg";
import ic_gopalerless from "../../assets/images/pictures/icon/ic_gopaperless.svg";
import solution_content from "../../assets/images/pictures/solution-content-1.png";
import ic_rectangle from "../../assets/images/pictures/icon/ic_rectangle.svg";
import ic_white_flag from "../../assets/images/pictures/icon/ic_flag.svg";
import ic_lightbulb from "../../assets/images/pictures/icon/ic-lightbulb-outline-black-24-px.svg";
import { useTranslation } from "react-i18next";
import fpt_logo from "../../assets/images/logos/itergrator/FPT_Software_logo.svg.png";
import cmc_ts_logo from "../../assets/images/logos/itergrator/CMC-TS-logo.png";
import vnpt_logo from "../../assets/images/logos/itergrator/vnpt-logo.png";
import misa_logo from "../../assets/images/logos/itergrator/MISA-logo.png";
import ctin_logo from "../../assets/images/logos/itergrator/ctin-logo-1.png";
import elcom_logo from "../../assets/images/logos/itergrator/ELCOM-logo.png";
import tma_solution_logo from "../../assets/images/logos/itergrator/TMA-Solutions-Logo.png";
import fsi_logo from "../../assets/images/logos/itergrator/FSI-logo-1.png";
import hipt_logo from "../../assets/images/logos/itergrator/HIPT-logo.png";
import hpt_logo from "../../assets/images/logos/itergrator/hpt-logo.png";
import { motion } from "framer-motion";
import routeVariants from "../../assets/animates/routeVariants";
import Footer from "./../global/Footer";
import NavbarBottom from "../global/NavbarBottom";
import logo_hilo_ca from "../../assets/images/logos/CA/hilo-ca.svg";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";

const SolutionsContent = () => {
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (modalOpen === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [modalOpen]);

  const modalRef = useRef(null);

  const handleOverlayClick = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setModalOpen(false);
    }
  };

  document.onkeydown = function (evt) {
    if (evt.code === "Escape") {
      setModalOpen(false);
    }
  };

  const { t } = useTranslation();

  return (
    <>
      <motion.div
        variants={routeVariants}
        initial="initial"
        animate="final"
        id="content"
        className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 no-transform"
      >
        <div className="container-fuild background-solution-image">
          <div className="container px-md-0 pt-50 pb-50">
            <div className="row">
              <div className="col-md-12 text-center">
                <h2 className="text-center font-weight-bold mx-auto text-yellow font-60">
                  {t("solutions-page.solutions-page-content.content-1.heading")}
                </h2>

                <p className="mt-25 mb-25 text-white">
                  {t(
                    "solutions-page.solutions-page-content.content-1.description"
                  )}
                </p>

                <a
                  href="javascript:;"
                  className="btn-primary"
                  onClick={() => setModalOpen(true)}
                >
                  {t(
                    "solutions-page.solutions-page-content.content-1.button-contact-us"
                  )}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="solutions-page bg-color-solution">
          <div className="container mb-100">
            <div className="row">
              <div className="col-sm-10 col-sm-offset-1 text-center">
                <div className="companies-text pt-32">
                  <p>
                    {t(
                      "solutions-page.solutions-page-content.content-2.description"
                    )}
                  </p>
                </div>
                <ul className="list-inline text-center">
                  <li>
                    <img
                      alt="FPT-CA"
                      title="FPT-CA"
                      className="client-s"
                      src={require("../../assets/images/logos/CA/FPT-CA.png")}
                    />
                  </li>
                  <li>
                    <img
                      alt="FAST-CA"
                      title="FAST-CA"
                      className="client-s"
                      src={require("../../assets/images/logos/CA/FastCA.png")}
                    />
                  </li>
                  <li>
                    <img
                      alt="WIN-CA"
                      title="WIN-CA"
                      className="client-s"
                      src={require("../../assets/images/logos/CA/WIN_Ca.png")}
                    />
                  </li>
                  <li>
                    <img
                      alt="CMC-CA"
                      title="CMC-CA"
                      className="client-s"
                      src={require("../../assets/images/logos/CA/cmcca1.png")}
                    />
                  </li>
                  <li>
                    <img
                      alt="EASY-CA"
                      title="EASY-CA"
                      className="client-s"
                      src={require("../../assets/images/logos/CA/easyca.png")}
                    />
                  </li>
                  <li>
                    <img
                      alt="I-CA"
                      title="I-CA"
                      className="client-s"
                      src={require("../../assets/images/logos/CA/i-ca.png")}
                    />
                  </li>
                  <li>
                    <img
                      alt="NCCA"
                      title="NCCA"
                      className="client-s"
                      src={require("../../assets/images/logos/CA/ncca.png")}
                    />
                  </li>
                  <li>
                    <img
                      alt="VGCA"
                      title="VGCA"
                      className="client-s"
                      src={require("../../assets/images/logos/CA/vgca.png")}
                    />
                  </li>
                  <li>
                    <img
                      alt="VIETTEL-CA"
                      title="VIETTEL-CA"
                      className="client-s"
                      src={require("../../assets/images/logos/CA/viettel-ca.png")}
                    />
                  </li>
                  <li>
                    <img
                      alt="BKAV-CA"
                      title="BKAV-CA"
                      className="client-s"
                      src={require("../../assets/images/logos/CA/bkav-ca.png")}
                    />
                  </li>
                  <li>
                    <img
                      alt="VNPT-CA"
                      title="VNPT-CA"
                      className="client-s"
                      src={require("../../assets/images/logos/CA/vnpt-ca.png")}
                    />
                  </li>
                  <li>
                    <img
                      alt="EFY-CA"
                      title="EFY-CA"
                      className="client-s"
                      src={require("../../assets/images/logos/CA/logo_efy.png")}
                    />
                  </li>
                  <li>
                    <img
                      alt="NACENCOMM-CA"
                      title="NACENCOMM-CA"
                      className="client-s"
                      src={require("../../assets/images/logos/CA/nacencomm.png")}
                    />
                  </li>
                  <li>
                    <img
                      alt="SMART-SIGN-CA"
                      title="SMART-SIGN-CA"
                      className="client-s"
                      src={require("../../assets/images/logos/CA/smart-sign.png")}
                    />
                  </li>
                  <li>
                    <img
                      alt="SAFE-CA"
                      title="SAFE-CA"
                      className="client-s"
                      src={require("../../assets/images/logos/CA/safe-ca.png")}
                    />
                  </li>
                  <li>
                    <img
                      alt="TRUST-CA"
                      title="TRUST-CA"
                      className="client-s"
                      src={require("../../assets/images/logos/CA/trustca.png")}
                    />
                  </li>
                  <li>
                    <img
                      alt="MISA-CA"
                      title="MISA-CA"
                      className="client-s"
                      src={require("../../assets/images/logos/CA/misaca.png")}
                    />
                  </li>
                  <li>
                    <img
                      alt="LCS-CA"
                      title="LCS-CA"
                      className="client-s"
                      src={require("../../assets/images/logos/CA/lcsca.png")}
                    />
                  </li>
                  <li>
                    <img
                      alt="NEWTEL-CA"
                      title="NEWTEL-CA"
                      className="client-s"
                      src={require("../../assets/images/logos/CA/newtelca.png")}
                    />
                  </li>
                  <li>
                    <img
                      alt="HILO-CA"
                      title="HILO-CA"
                      className="client-s"
                      src={logo_hilo_ca}
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="container description px-md-0">
            <div className="row">
              <div className="col-md-6 col-md-offset-3 text-center mb-50">
                <img
                  width="64"
                  height="64"
                  src={ic_chart_big_circle}
                  className="mb-20"
                  alt=""
                  decoding="async"
                  loading="lazy"
                  data-no-retina=""
                />
                <h2 className="font-weight-bold">
                  {t(
                    "solutions-page.solutions-page-content.content-3.big-heading"
                  )}
                </h2>
              </div>
            </div>

            <div className="row text-center mb-100">
              <div className="col-md-4">
                <h3>
                  {t(
                    "solutions-page.solutions-page-content.content-3.small-heading-1"
                  )}
                </h3>
                <p>
                  {t(
                    "solutions-page.solutions-page-content.content-3.small-description-1"
                  )}
                </p>
              </div>
              <div className="col-md-4">
                <h3>
                  {t(
                    "solutions-page.solutions-page-content.content-3.small-heading-2"
                  )}
                </h3>
                <p>
                  {t(
                    "solutions-page.solutions-page-content.content-3.small-description-2"
                  )}
                </p>
              </div>
              <div className="col-md-4">
                <h3>
                  {t(
                    "solutions-page.solutions-page-content.content-3.small-heading-3"
                  )}
                </h3>
                <p>
                  {t(
                    "solutions-page.solutions-page-content.content-3.small-description-3"
                  )}
                </p>
              </div>
            </div>
          </div>

          <div className="bg-primary btn-boxes">
            <div className="container px-md-0 ">
              <div className="row text-center mt-30">
                <div id="all" className="col-md-8 col-md-offset-2">
                  <img
                    width="35"
                    height="6"
                    src={ic_rectangle}
                    className="mb-24"
                    alt=""
                    decoding="async"
                    loading="lazy"
                    data-no-retina=""
                  />
                  <h2 className="font-weight-bold text-white">
                    {t(
                      "solutions-page.solutions-page-content.content-4.big-heading"
                    )}
                  </h2>

                  <p className="mb-25 text-white">
                    {t(
                      "solutions-page.solutions-page-content.content-4.big-description"
                    )}
                  </p>
                </div>
              </div>

              <div className="boxes-overview text-center">
                <div className="boxes-overview__box">
                  <Link
                    className="panel"
                    id="button-portal-api-en"
                    to="/solutions/signature-collection"
                  >
                    <div className="panel-body box">
                      <div className="ic-box">
                        <img
                          width="40"
                          height="40"
                          src={ic_devices}
                          className="attachment-full size-full"
                          alt=""
                          decoding="async"
                          loading="lazy"
                          data-no-retina=""
                        />
                      </div>
                      <h4 className="font-weight-bold">
                        {t(
                          "solutions-page.solutions-page-content.content-4.small-heading-1"
                        )}
                      </h4>
                      <h4>
                        {t(
                          "solutions-page.solutions-page-content.content-4.small-description-1"
                        )}
                      </h4>
                    </div>
                  </Link>
                </div>
                <div className="boxes-overview__box">
                  <Link
                    className="panel"
                    id="button-portal-api-en"
                    to="/solutions/e-signing-api"
                  >
                    <div className="panel-body box">
                      <div className="ic-box">
                        <img
                          width="40"
                          height="40"
                          src={ic_paper_circle}
                          className="attachment-full size-full"
                          alt=""
                          decoding="async"
                          loading="lazy"
                          data-no-retina=""
                        />
                      </div>
                      <h4 className="font-weight-bold">
                        {t(
                          "solutions-page.solutions-page-content.content-4.small-heading-2"
                        )}
                      </h4>
                      <h4>
                        {t(
                          "solutions-page.solutions-page-content.content-4.small-description-2"
                        )}
                      </h4>
                    </div>
                  </Link>
                </div>
                <div className="boxes-overview__box">
                  <Link
                    className="panel"
                    id="button-portal-api-en"
                    to="/solutions/e-identification-api"
                  >
                    <div className="panel-body box">
                      <div className="ic-box">
                        <img
                          width="40"
                          height="40"
                          src={ic_person_circle}
                          className="attachment-full size-full"
                          alt=""
                          decoding="async"
                          loading="lazy"
                          data-no-retina=""
                        />
                      </div>
                      <h4 className="font-weight-bold">
                        {t(
                          "solutions-page.solutions-page-content.content-4.small-heading-3"
                        )}
                      </h4>
                      <h4>
                        {t(
                          "solutions-page.solutions-page-content.content-4.small-description-3"
                        )}
                      </h4>
                    </div>
                  </Link>
                </div>
                <div className="boxes-overview__box">
                  <Link
                    className="panel"
                    id="button-portal-api-en"
                    to="/solutions/e-sealing-api"
                  >
                    <div className="panel-body box">
                      <div className="ic-box">
                        <img
                          width="40"
                          height="40"
                          src={ic_setting}
                          className="attachment-full size-full"
                          alt=""
                          decoding="async"
                          loading="lazy"
                          data-no-retina=""
                        />
                      </div>
                      <h4 className="font-weight-bold">
                        {t(
                          "solutions-page.solutions-page-content.content-4.small-heading-4"
                        )}
                      </h4>
                      <h4>
                        {t(
                          "solutions-page.solutions-page-content.content-4.small-description-4"
                        )}
                      </h4>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="container features-page__container features-page__container--margin px-md-0">
            <div className="row">
              <div className="col-md-6 col-sm-12 pt-50">
                <img
                  width="64"
                  height="64"
                  src={ic_globe_big_circle}
                  className="attachment-full size-full"
                  alt=""
                  decoding="async"
                  loading="lazy"
                  data-no-retina=""
                />
                <h2 className="heading font-weight-bold">
                  {t(
                    "solutions-page.solutions-page-content.content-5.big-heading"
                  )}
                </h2>
                <p className="mt-25 mb-25">
                  {t(
                    "solutions-page.solutions-page-content.content-5.big-description"
                  )}
                </p>
                <div className="boxes boxes--vertical">
                  <div className="boxes__item boxes-two-col">
                    <div className="col">
                      <img
                        width="24"
                        height="24"
                        src={ic_white_flag}
                        className="attachment-full size-full"
                        alt=""
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                    </div>
                    <div className="col">
                      <h5 className="heading">
                        {t(
                          "solutions-page.solutions-page-content.content-5.small-heading-1"
                        )}
                      </h5>
                      <p>
                        {t(
                          "solutions-page.solutions-page-content.content-5.small-description-1"
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="boxes__item boxes-two-col">
                    <div className="col">
                      <img
                        width="14"
                        height="20"
                        src={ic_lightbulb}
                        className="attachment-full size-full"
                        alt=""
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                    </div>
                    <div className="col">
                      <h5 className="heading">
                        {t(
                          "solutions-page.solutions-page-content.content-5.small-heading-2"
                        )}
                      </h5>
                      <p>
                        {t(
                          "solutions-page.solutions-page-content.content-5.small-description-2"
                        )}
                        &nbsp;
                        <Link to="/eids" target="_blank" rel="noreferrer">
                          {t(
                            "solutions-page.solutions-page-content.content-5.small-description-2-1"
                          )}
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-sm-12 mt-60">
                <img
                  src={map_final}
                  className="img-responsive"
                  alt=""
                  decoding="async"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          <div className="container mb-100 mt-100">
            <div className="row">
              <div className="col-sm-10 col-sm-offset-1 text-center">
                <img
                  width="64"
                  height="64"
                  src={ic_persons_big_circle}
                  className="integrators icon"
                  alt=""
                  decoding="async"
                  loading="lazy"
                  data-no-retina=""
                />
                <div className="companies-text">
                  <h2 className="font-weight-bold">
                    {t(
                      "solutions-page.solutions-page-content.content-6.heading"
                    )}
                  </h2>
                  <p className="mt-25 mb-25">
                    {t(
                      "solutions-page.solutions-page-content.content-6.description"
                    )}
                  </p>
                </div>
                <ul className="list-inline text-center">
                  <li>
                    <a
                      href="https://fptsoftware.com"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        height="70px"
                        src={fpt_logo}
                        className="client-s"
                        alt="FPT-Software"
                        decoding="async"
                        loading="lazy"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://cmcts.com.vn"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        height="70px"
                        src={cmc_ts_logo}
                        className="client-s"
                        alt="CMC-TS"
                        decoding="async"
                        loading="lazy"
                        style={{ height: "auto" }}
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://vnpt-technology.vn"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        height="70px"
                        src={vnpt_logo}
                        style={{ height: "auto" }}
                        className="client-s"
                        alt="VNPT"
                        decoding="async"
                        loading="lazy"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.misa.vn"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        height="70px"
                        src={misa_logo}
                        className="client-s"
                        alt="MISA"
                        decoding="async"
                        loading="lazy"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.ctin.vn/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        height="70px"
                        src={ctin_logo}
                        className="client-s"
                        alt="CTIN"
                        decoding="async"
                        loading="lazy"
                        style={{ height: "auto" }}
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.elcom.com.vn/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        height="70px"
                        src={elcom_logo}
                        className="client-s"
                        alt="ELCOM"
                        decoding="async"
                        loading="lazy"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.tmasolutions.vn/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        height="70px"
                        src={tma_solution_logo}
                        className="client-s"
                        alt="TMA-Solutions"
                        decoding="async"
                        loading="lazy"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://fsivietnam.com.vn/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        height="70px"
                        src={fsi_logo}
                        className="client-s"
                        alt="FSI"
                        decoding="async"
                        loading="lazy"
                      />
                    </a>
                  </li>
                  <li>
                    <a href="https://hipt.vn/" target="_blank" rel="noreferrer">
                      <img
                        height="70px"
                        src={hipt_logo}
                        className="client-s"
                        alt="HIPT"
                        decoding="async"
                        loading="lazy"
                      />
                    </a>
                  </li>
                  <li>
                    <a href="https://hpt.vn/" target="_blank" rel="noreferrer">
                      <img
                        height="70px"
                        src={hpt_logo}
                        className="client-s"
                        alt="HPT"
                        decoding="async"
                        loading="lazy"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-primary security-footer">
            <div className="container security-footer">
              <div className="row">
                <div className="col-sm-8 col-sm-offset-2 text-center mbt-40">
                  <img
                    width="64"
                    height="64"
                    src={ic_gopalerless}
                    className="attachment-full size-full"
                    alt=""
                    decoding="async"
                    loading="lazy"
                    data-no-retina=""
                  />
                  <h2 className="font-weight-bold text-white">
                    {t(
                      "solutions-page.solutions-page-content.content-7.heading"
                    )}
                  </h2>
                  <p className="mb-25 mt-25 text-white">
                    {t(
                      "solutions-page.solutions-page-content.content-7.description"
                    )}
                  </p>
                  <Link to="/compliance" className="btn-secondary" target="">
                    {t(
                      "solutions-page.solutions-page-content.content-7.button-learnmore"
                    )}
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="container mb-25 mt-25 px-md-0">
              <div className="row">
                <div className="col-sm-6 text-xs-center pt-20">
                  <h2 className="heading font-weight-bold">
                    {t(
                      "solutions-page.solutions-page-content.content-8.heading"
                    )}
                  </h2>
                  <p className="subheading mb-25 mt-25">
                    {t(
                      "solutions-page.solutions-page-content.content-8.description"
                    )}
                  </p>
                  {/* <a href="javascript:;" className="btn-secondary">
                    {t(
                      "solutions-page.solutions-page-content.content-8.button-learnmore"
                    )}
                  </a> */}
                </div>
                <div className="col-sm-6">
                  <img
                    src={solution_content}
                    width="350"
                    height="300"
                    className="img-responsive"
                    alt=""
                    decoding="async"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
        <NavbarBottom />
      </motion.div>
      {modalOpen && (
        <Modal
          setOpenModal={setModalOpen}
          handleOverlayClick={handleOverlayClick}
          modalRef={modalRef}
          heading={t("modal.heading-integrate")}
          description={t("modal.description-fillout-find-solution")}
          type="Solutions"
        />
      )}
      <ToastContainer />
    </>
  );
};

export default SolutionsContent;
